import { memo } from "react";
import styled from "styled-components";
import size from "../../../helpers/size";
import color from "../../../helpers/color";
import textSize from "../../../helpers/textSize";
import transparentize from "../../../helpers/transparentize";
const Label = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Label",
  componentId: "sc-ahc6gv-0"
})(["", " ", " display:inline-block;border-radius:2px;background-color:", ";color:", ";text-align:center;"], size, textSize, transparentize, color));
Label.defaultProps = {
  size: "tiny",
  textSize: "tiny",
  color: "default"
};
export default Label;
//# sourceMappingURL=index.js.map